<div class="loginContainer d-flex" style="height: 100vh;">

  <div class="w-50 h-100">


    <div id="carousel" class="carousel slide h-100" data-bs-ride="carousel" data-bs-interval="5000" data-bs-pause="false">
        <div class="carousel-indicators">
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
      <div class="carousel-inner h-100">
        <div class="carousel-item active h-100 position-relative">
          <img src="assets/img/photos/final LOCA 3122.jpg" class="d-block w-100 h-100"
            style="object-fit: cover; object-position: center;" alt="...">
          <div class="position-absolute top-0 start-0 w-100 h-100" style="background: rgba(0, 0, 0, 0.4);"></div>
          <div class="carousel-caption d-none d-md-block">
            <h5>{{'image1Title' | translate}}</h5>
            <p>{{'image1Desc' | translate}}</p>
          </div>
        </div>
        <div class="carousel-item h-100 position-relative">
          <img src="assets/img/photos/FOTO VIARIS COMBI + CON NUEVO FRONTAL.png" class="d-block w-100 h-100"
            style="object-fit: cover; object-position:  center;" alt="...">
          <div class="position-absolute top-0 start-0 w-100 h-100" style="background: rgba(0, 0, 0, 0.4);"></div>
          <div class="carousel-caption d-none d-md-block">
            <h5>{{'image2Title' | translate}}</h5>
            <p>{{'image2Desc' | translate}}</p>
          </div>
        </div>
        <div class="carousel-item h-100 position-relative">
          <img src="assets/img/photos/WhatsApp Image 2025-06-06 at 11.59.12.jpeg" class="d-block w-100 h-100"
            style="object-fit: cover; object-position: right;" alt="...">
          <div class="position-absolute top-0 start-0 w-100 h-100" style="background: rgba(0, 0, 0, 0.4);"></div>
          <div class="carousel-caption d-none d-md-block">
            <h5>{{'image3Title' | translate}}</h5>
            <p>{{'image3Desc' | translate}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>



  <div class="w-50 h-100 d-flex justify-content-center align-items-center flex-column p-5">

    <!-- Vista Access (login principal) -->
    <div *ngIf="currentView === 'access'">
      <app-access></app-access>
    </div>

    <!-- Vista Forgot Password -->
    <div *ngIf="currentView === 'forgot'">
      <app-new-forgot></app-new-forgot>
    </div>

    <!-- Vista Register -->
    <div *ngIf="currentView === 'register'">
      <app-register></app-register>
    </div>

  </div>
</div>
